import { compose, withProps } from 'recompose';
import { Redirect } from 'react-router-dom';

import withLocale from 'app/features/localization/enhancers/withLocale';
import localizeLink from 'app/features/localization/localizeLink';
import withAppName from 'app/enhancers/withAppName';

const to = ({ query = '', path = '', appName, locale }) => ({
  to: localizeLink(`/${appName}${path}${query}`, locale),
});

const LandingRedirect = compose(
  withLocale,
  withAppName,
  withProps(to),
)(Redirect);

export { to };

export default LandingRedirect;
